import {AuthGuard} from '../../shared/services';
import { CategoryAssociationDetailsRoutes } from './category-association-details/category-association-details.routes';
import { CategoryAssociationListRoutes } from './category-association-list/category-association-list.routes';
import { CategoryAssociationComponent } from './category-association.component';
import {Route} from '@angular/router';

export const CategoryAssociationRoutes: Route[] = [
  {
    path: 'assoc_category',
    component: CategoryAssociationComponent,
    canActivate: [AuthGuard],
    children: [
      ...CategoryAssociationListRoutes,
      ...CategoryAssociationDetailsRoutes
    ]
  }
];
